import { render, staticRenderFns } from "./CompanyWelcome.vue?vue&type=template&id=705d58b0&scoped=true"
import script from "./CompanyWelcome.vue?vue&type=script&lang=js"
export * from "./CompanyWelcome.vue?vue&type=script&lang=js"
import style0 from "./CompanyWelcome.vue?vue&type=style&index=0&id=705d58b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d58b0",
  null
  
)

export default component.exports